module.exports = __webpack_public_path__ + "files/05d5a332f46e19a1802b6d3fefe69189.png";